const UNASSIGNED_AVATAR_COLOR = '#E4E7EC';

export function getAccountabilityAvatarColor(personId?: string | null) {
  const seed = personId?.trim();
  if (!seed) return UNASSIGNED_AVATAR_COLOR;

  let hash = 0;
  for (let index = 0; index < seed.length; index += 1) {
    hash = (hash * 31 + seed.charCodeAt(index)) >>> 0;
  }

  const hue = hash % 360;
  return `hsl(${hue}, 68%, 44%)`;
}
